/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbBranchList } from './HchbBranchList';
import {
    HchbBranchListFromJSON,
    HchbBranchListFromJSONTyped,
    HchbBranchListToJSON,
} from './HchbBranchList';

/**
 * 
 * @export
 * @interface FindAllHchbBranches200Response
 */
export interface FindAllHchbBranches200Response {
    /**
     * 
     * @type {HchbBranchList}
     * @memberof FindAllHchbBranches200Response
     */
    data?: HchbBranchList;
}

/**
 * Check if a given object implements the FindAllHchbBranches200Response interface.
 */
export function instanceOfFindAllHchbBranches200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllHchbBranches200ResponseFromJSON(json: any): FindAllHchbBranches200Response {
    return FindAllHchbBranches200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbBranches200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbBranches200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HchbBranchListFromJSON(json['data']),
    };
}

export function FindAllHchbBranches200ResponseToJSON(value?: FindAllHchbBranches200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HchbBranchListToJSON(value.data),
    };
}

